import { isLocalDevServerHostname } from "#is-local-dev-server-hostname";
import { isLoopbackHostname } from "#is-loopback-hostname";

/**
 * Whether a dev client loaded its bundle (Expo's `hostUri`) through a public tunnel domain such as
 * `metro.haniverse.dev`, rather than from a dev server on this machine or its network. Such a device
 * can be anywhere, so none of the stack's loopback or LAN service URLs reach it.
 */
export function isTunnelDevServerHostUri(hostUri: string | null | undefined): boolean {
  if (hostUri == null || hostUri.length === 0) {
    return false;
  }
  let hostname: string;
  try {
    hostname = new URL(`http://${hostUri}`).hostname;
  } catch {
    return false;
  }
  return !isLoopbackHostname(hostname) && !isLocalDevServerHostname(hostname);
}
